import { Component, OnInit } from '@angular/core';

@Component({
	selector: 'app-img-default',
	templateUrl: './image-default.component.html',
	styleUrls: ['./image-default.component.scss'],
})
export class ImageDefaultComponent implements OnInit {
	constructor() {}

	ngOnInit(): void {}
}
